import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled, { keyframes } from 'styled-components';
var spin = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"], ["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"])));
var spinnerWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: ", "px solid\n    ", ";\n  border-top: ", "px solid\n    ", ";\n  border-radius: 50%;\n  width: ", "px;\n  height: ", "px;\n  animation: ", " ", "ms linear infinite;\n"], ["\n  border: ", "px solid\n    ", ";\n  border-top: ", "px solid\n    ", ";\n  border-radius: 50%;\n  width: ", "px;\n  height: ", "px;\n  animation: ", " ", "ms linear infinite;\n"])), function (props) {
  return props.size / 7.5;
}, function (props) {
  var _a, _b;

  return (_a = props.borderColor) !== null && _a !== void 0 ? _a : (_b = props.theme.palette) === null || _b === void 0 ? void 0 : _b.lighter;
}, function (props) {
  return props.size / 7.5;
}, function (props) {
  var _a, _b;

  return (_a = props.spinnerColor) !== null && _a !== void 0 ? _a : (_b = props.theme.palette) === null || _b === void 0 ? void 0 : _b.brandBlue;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, spin, function (props) {
  return props.animationSpeedMs;
});
var templateObject_1, templateObject_2;
export { spinnerWrapper };